import React from 'react';
import './App.css';
import BeerStore from './components/BeerStore';

function App() {
    return (
        <BeerStore />
  );
}

export default App;
